import styled from 'styled-components'
import { color, space } from 'styled-system'

export const Box = styled.div`
  ${color}
  ${space}
`
